import { English, French, SpanishSpain, SpanishLatam, German, Italian, Portuguese } from './languages';

export interface AppStrings {
    or: string;
    max: string;
    back: string;
    submit: string;
    accept: string;
    purchase: string;
    no_thanks: string;
    thank_you: string;
    cancel: string;
    close: string;
    open: string;
    option_unavailable: string;
    confirm: string;

    my_trip: string;
    finalize_trip: string;
    trip_all_set: string;
    manage_guests_capitalized: string;
    manage_guests_title: string;
    manage_pets_title: string;
    manage_pets_error: string;
    add_pet_refund_btn: string;
    add_pet_update_balance_title: string;
    add_pet_checkout_title: string;
    add_remove_guest: string;
    modify_your_trip: string;
    instructions_for_modify_guests: string;
    instructions_for_modify_guests_pets: string;
    extra_instructions_for_modify_pet: string;
    max_occupancy_modify_guests: string;
    instructions_for_modify_pets: string;
    instructions_for_modify_pet: string;
    getting_there: string;
    features_and_amenities_capitalized: string;
    in_the_home: string;
    checkout_instructions: string;
    codes_will_be_provided: string;
    alarm_code: string;
    lockbox_code: string;
    e_lock_codes: string;
    gate_access: string;
    stay_longer: string;
    location_and_parking: string;
    on_your_way: string;
    directions_to_know: string;
    directions_and_parking_notes: string;
    parking_spaces: string;
    parking_notes: string;
    entering_home: string;
    home_access_details: string;
    house_rules: string;
    internet_access: string;
    network: string;
    password: string;
    passwords_will_be_provided: string;

    reservation: string;
    trip_overview: string;
    nights: string;
    max_occupancy: string;
    can_add_guest: string;
    can_not_add_guest: string;
    click_here_to_get_code: string;
    guest: string;
    guests: string;
    confirmation: string;
    view_listing: string;

    rental_agreement: string;
    sign_agreement: string;
    sign_by: string;
    sign_agreement_by: string;
    signed_on: string;
    i_agree_terms: string;
    agreed_on: string;
    i_agree_new_terms: string;
    agreed_new_terms_on: string;
    agreed_new_terms_on_date: string;
    unit_terms_text: string;
    unit_terms_alert: string;
    new_terms_required_text: string;
    new_terms_instructions_text: string;
    new_terms_submit_btn: string;
    view_agreement: string;
    print_header_text: string;
    print_step_one: string;
    print_step_two: string;
    print_button: string;
    print_email_label: string;
    print_fax_label: string;
    print_email_value: string;
    print_fax_value: string;
    print_booked_by: string;
    print_on: string;

    payment_details: string;
    make_payment: string;
    pay_balance: string;
    payment_complete: string;
    pay_by: string;
    pay_balance_by: string;
    view_receipt: string;

    refund_going_to: string;
    original_payment_methods: string;
    guest_paid: string;
    total_refund: string;
    refund_details: string;
    original_payment: string;

    cancellation_charges: string;
    sure_you_want_to_cancel: string;
    yes_cancel_now: string;
    no_dont_cancel: string;
    cancel_trip: string;
    cancel_and_receive_refund: string;
    view_cancellation_policy: string;

    vehicle_registration: string;
    vehicle: string;
    list_your_vehicles: string;
    register_vehicle: string;
    max_vehicles_reached: string;
    group_has_no_vehicles: string;
    register_by: string;
    register_vehicles_by: string;
    add_vehicle_info: string;
    add_a_vehicle_button: string;
    add_vehicle_title: string;
    add_vehicle_text: string;
    vehicle_added: string;
    edit_a_vehicle_button: string;
    edit_vehicle_title: string;
    edit_vehicle_text: string;
    remove_vehicle_title: string;
    remove_vehicle_button: string;
    remove_vehicle_text: string;
    my_group_has_no_vehicles_title: string;
    my_group_has_no_vehicles_confirm_text: string;
    my_group_has_no_vehicles_confirm_button: string;
    license_plate: string;
    state_province: string;
    other: string;
    location: string;

    finalize_your_reservation: string;
    these_actions_are_required: string;

    add_on: string;
    pool_heat: string;
    pool_heat_added: string;
    pool_heat_add_or_remove: string;
    pool_heat_note: string;
    need_help: string;
    visit_our: string;
    support_center: string;
    still_have_questions: string;
    please_reach: string;

    home_essentials: string;
    no_beds: string;
    king_bed: string;
    king_bed_plural: string;
    queen_bed: string;
    queen_bed_plural: string;
    double_bed: string;
    double_bed_plural: string;
    twin_bed: string;
    twin_bed_plural: string;
    child_bed: string;
    child_bed_plural: string;
    murphy_bed: string;
    murphy_bed_plural: string;

    no_bathrooms: string;
    full_bath: string;
    full_bath_plural: string;
    half_bath: string;
    half_bath_plural: string;
    sleeps: string;

    loading: string;
    updated_successfully: string;
    read_more: string;
    read_less: string;

    who_is_coming: string;
    invite_guest: string;
    invite_guest_note: string;
    invite_guest_note_same_day: string;
    add_guest: string;
    edit_guest: string;
    remove_guest: string;
    edit_guest_note_modal: string;
    invite_guest_info: string;
    email_addresses_guests: string;
    modify_guest_note: string;
    modify_guest_add_note: string;
    need_cancel_trip: string;
    need_cancel_note: string;
    cancel_trip_options: string;
    name: string;
    first_name: string;
    last_name: string;
    email_address: string;
    invite_guest_note_modal: string;
    yes_remove_invited: string;
    no_remove_invited: string;
    can_add_pet: string;
    can_add_pets: string;
    can_not_add_pet: string;
    pet: string;
    pets: string;
    remove_invite_note: string;
    are_you_sure: string;

    cookie_disclaimer: string;
    read_cookie_policy: string;

    sitemap: string;
    privacy: string;
    terms_of_service: string;

    property_management: string;
    real_estate: string;
    company: string;
    innovation: string;
    about_us: string;
    blog: string;
    careers: string;
    newsroom: string;
    investors: string;
    leadership: string;
    solutions_partnerships: string;
    community: string;
    accessibility: string;
    social_responsibility: string;
    help: string;
    support_contact: string;
    toll_free: string;
    local: string;
    covid_update: string;
    hi: string;
    my_trips: string;
    favorites: string;
    profile: string;
    logout: string;
    owner_portal: string;
    owner_login: string;
    login: string;
    find_my_trip: string;
    my_account: string;
    language_and_currency: string;

    somethings_not_right: string;
    an_error_occurred: string;
    try_later_or_call: string;
    something_went_wrong: string;
    error_cancelling: string;
    contact_customer_service: string;

    identity_check_required: string;
    verify_identity: string;

    already_completed_idv: string;
    click_here: string;

    guest_portal_unavailable: string;
    resolve_issues_calling: string;

    session_expired: string;
    session_expired_message: string;

    access_token_expired: string;
    access_token_expired_message: string;

    trip_overview_capitalized: string;
    getting_there_capitalized: string;

    modify_your_trip_capitalized: string;
    checkout_instructions_capitalized: string;

    wheres_my_receipt: string;
    channel_receipt_note: string;

    trip_eligibility_trip_already_started: string;
    trip_eligibility_pending_payment: string;
    trip_eligibility_created_before_june_fourth_2018: string;
    trip_eligibility_negative_balance: string;
    trip_eligibility_not_allowed_for_occupancy: string;
    trip_eligibility_refund_in_progress: string;

    download_app_mobile_note: string;
    download_app_mobile_title: string;

    payment_title: string;
    receipt_title: string;
    addons_title: string;
    latecheckout_title: string;
    modify_trip_title: string;

    rent: string;
    fees: string;
    taxes: string;
    trip_protection: string;
    not_purchased: string;
    previous_balance: string;
    sub_total: string;
    pet_refund: string;
    adult_added: string;
    adults_added: string;
    pet_added: string;
    pets_added: string;
    child_added: string;
    children_added: string;

    balance_due: string;
    balance_in: string;
    new_balance_due: string;
    total_in: string;
    processed_in_currency_notice: string;

    submit_guest_edition: string;
    confirm_guest_remove: string;

    payment_processed_by: string;
    billing_address: string;

    ready_to_checkout: string;
    note_early_checkout: string;
    checkout_now: string;
    not_ready_yet: string;
    all_set: string;
    note_confirm_early_checkout: string;
    got_it: string;
    note_cancel_early_cehckout: string;

    view_receipt_capitalized: string;
    receipt_thirty_party_channel: string;

    covid19_text: string;
    covid19_button_text: string;
    covid19_link: string;

    square_feet: string;

    browser_deprecated: string;
    please_upgrade_browser: string;

    know_before_you_go: string;
    import_details: string;
    directions_and_parking_details: string;
    note_for_our_guests: string;

    cannot_perform_action_title: string;
    cannot_perform_action_message: string;

    fsc_credits: string;

    address: string;
    features_and_amenities: string;

    cancel_trip_title: string;

    payment_form_add_night: string;
    payment_form_add_night_note: string;
    payment_form_pricing_details: string;
    payment_form_pricing_discounted_rent: string;
    payment_form_pricing_discount: string;
    payment_form_total: string;
    payment_form_billing_information: string;
    payment_form_billing_name: string;
    payment_form_country: string;
    payment_form_city: string;
    payment_form_city_or_town: string;
    payment_form_governorate: string;
    payment_form_area: string;
    payment_form_region: string;
    payment_form_county: string;
    payment_form_province: string;
    payment_form_island: string;
    payment_form_parish: string;
    payment_form_prefecture: string;
    payment_form_emirate: string;

    payment_form_state: string;
    payment_form_postal_code: string;
    payment_form_department: string;
    payment_form_zip_code: string;
    payment_form_card_number: string;
    payment_form_expiration_date: string;
    payment_form_expiration_month: string;
    payment_form_expiration_year: string;
    payment_form_security_code: string;
    payment_form_payments_note: string;
    payment_form_pay_now: string;
    payment_form_visa: string;
    payment_form_master_card: string;
    payment_form_discover: string;
    payment_form_reservation_details: string;
    payment_form_adult: string;
    payment_form_adults: string;
    payment_form_child: string;
    payment_form_children: string;
    payment_form_month: string;
    payment_form_year: string;
    payment_successful: string;
    payment_successful_note: string;
    payment_failed: string;
    payment_call_us_to_complete: string;
    payment_call_us_to_complete_start: string;
    payment_call_us_to_complete_end: string;
    payment_form_removed: string;
    payment_form_added: string;
    payment_successful_generic_note: string;
    payment_trip_paid_in_full: string;
    payment_successful_add_pet_adjustment_note: string;
    payment_successful_add_pet_adjustment_refund_note: string;
    payment_successful_add_pool_heat_adjustment_note: string;

    modal_adjustment_not_available_continue: string;
    modal_adjustment_not_available_back_to_trip: string;
    modal_adjustment_not_available_title: string;
    modal_adjustment_not_available_note_start: string;
    modal_adjustment_not_available_note_end: string;

    modal_lco_adjustment_not_available_title: string;
    modal_lco_adjustment_not_available_note_start: string;
    modal_lco_adjustment_pending_balance_note_start: string;

    modal_adjustment_pending_balance_title: string;
    modal_adjustment_pending_balance_note_start: string;
    modal_adjustment_pending_balance_note_end: string;

    night_added: string;
    nights_added: string;

    maintenance_window_title: string;
    maintenance_window_note: string;
    maintenance_go_to_home: string;
    maintenance_link: string;

    modal_cancel_go_to_my_trips: string;
    modal_cancel_title: string;
    modal_cancel_note: string;

    billing_information_note: string;

    adjustment_failed_title: string;

    whats_nearby: string;
    whats_nearby_capitalized: string;
    checkout_best_of_city: string;
    banking: string;
    restaurants_and_coffee: string;
    groceries: string;
    hospitals: string;
    movie_theaters: string;
    bars_and_nightlife: string;
    parks: string;
    pharmacies: string;
    shopping: string;
    sports: string;
    universities: string;
    tourist_attractions: string;
    filter_by_category: string;

    star_rating_title: string;
    star_rating_note: string;
    next: string;

    pay_balance_issue: string;

    chat_default_message: string;
    chat_default_name: string;
    chat_start_new_button: string;
    chat_start_content: string;
    chat_open: string;
    chat_message_close: string;
    chat_rule_close: string;
    chat_rule: string;
    chat_error: string;
    chat_loading: string;
    chat_me: string;

    extended_stay_capitalized: string;
    extended_stay_rules: string;
    extended_stay_success_alert_plural: string;
    extended_stay_success_alert: string;
    extended_stay_error_message: string;
    extended_stay_note_message: string;
    check_in: string;
    check_in_description: string;
    check_out: string;
    check_out_description: string;
    empty_calendar_before_options: string;
    empty_calendar_after_options: string;
    payment_form_add_extended_stay: string;
    today: string;
    clear: string;
    checkout: string;
    reset_dates: string;
    total_cost: string;
    late_check_out_capitalized: string;
    payment_form_add_late_check_out_note: string;
    payment_form_add_late_check_out: string;

    bedroom_title: string;
    view_all_beds: string;
    view_less: string;
    view_more: string;

    pool_heat_capitalized: string;
}

export const messages: { [lang: string]: AppStrings } = {
    en: English,
    es: SpanishLatam,
    'es-419': SpanishLatam,
    'es-ES': SpanishSpain,
    fr: French,
    de: German,
    pt: Portuguese,
    it: Italian,
};
